export default {
  'checkoutForm.buyButton': 'Desde México',
  'checkoutForm.sellButton': 'Hacia México',
  'checkoutForm.checkWalletAddress': 'Chequea la dirección de tu billetera',
  'checkoutForm.doNotHaveWallet': 'No tenes una billetera?',
  'checkoutForm.enterHigherValue': 'El valor mínimo de compra es {{fiatAsset}} {{minAmount}}',
  'checkoutForm.enterHigherValue.withdraw': 'El valor mínimo de venta es {{cryptoAsset}} {{minAmount}}',
  'checkoutForm.enterLowerValue': 'Ingresa un valor menor',
  'checkoutForm.enterValidEmail': 'El email no es válido',
  'checkoutForm.enterYourAmount': 'Ingresa el importe',
  'checkoutForm.enterYourEmail': 'Ingresa tu email',
  'checkoutForm.enterYourWallet': 'Ingresa tu billetera',
  'checkoutForm.enterYourTranRef': 'Ingresa tu Numero de Transacción',
  'checkoutForm.submitBtn.Deposit': 'Comprar',
  'checkoutForm.submitBtn.Withdraw': 'Vender',
  'checkoutForm.Deposit': 'Depósito de dinero',
  'checkoutForm.Withdraw': 'Retiro de dinero',
  'checkoutForm.wantToSpend': 'La cantidad de',
  'checkoutForm.wantToBuy': 'Quiero enviar',
  'checkoutForm.wantToSell': 'Recibe',
  'checkoutForm.wantToReceive': 'Quiero recibir',
  'checkoutForm.includedFees': 'Fees incluídos',
  'checkoutForm.minAmountError': 'El valor mínimo de compra es {{fiatAsset}} {{minAmount}}',
  'checkoutForm.minAmountError.withdraw': 'El valor mínimo de venta es {{cryptoAsset}} {{minAmount}}',
  'checkoutForm.mustEnterValue': 'Debes ingresar algun valor',
  'checkoutForm.termsCondDisclaimer':
    'El precio incluye los gastos del procesador de pagos desde {{fee}}%{{minFeeString}}{{flatFeeString}}. Al continuar estas aceptando los <1>términos y condiciones</1>.',
  'checkoutForm.flatFee': ' + cargo fijo {{fiatAsset}} {{flatFee}}',
  'checkoutForm.tooltip':
    'Precio basado en la cotización actual.<br/>La cotización final puede variar una vez<br/> que se acredite su pago. Una vez <br/>recibido su pago, se le enviará un <br/>correo electrónico para  que confirme <br/>la transacción con la tarifa final.',
  'checkoutForm.exchangeToReceive': 'Recibir en la wallet',
  'checkoutForm.myEmail': 'Mi correo electrónico',
  'checkoutForm.weNeedYourEmail': 'Necesitamos tu correo para la orden',
  'checkoutForm.getStarted': 'Comenzar',
  'checkoutForm.whatIsYourWallet': '¿Cuál es tu otra wallet?',
  'checkoutForm.maxCharacters': 'La cantidad máxima de caracteres es de 50',
  'checkoutForm.alphaNumeric': 'Solo están permitidos caracteres alfanuméricos'
};
